import angular from 'angular';

SubsetPopover.$inject = ['$window', 'apiBaseURl', 'djangoClient'];

export function SubsetPopover($window, apiBaseURl, djangoClient) {
    const vm = angular.extend(this, {
        downloadType: 'subsets',
        selectedSubsets: { custom: '', subsets: [] },
        initialize,
        downloadSubsets,
    });

    function initialize(licenses, web) {
        vm.licenses = licenses;
        vm.web = web;
        vm.selectedSubsets = { custom: '', subsets: [] };
        let subsets = licenses.reduce((result, item) => {
            const itemSubsets = item.style.available_subsets.map((subset) => {
                const label = Object.keys(subset)[0];
                subset[label].label = label;
                return subset[label];
            });

            if (!result.length) {
                result = itemSubsets;
            } else {
                result = result.filter(
                    (subset) => itemSubsets.indexOf(subset) !== -1
                );
            }
            return result;
        }, []);

        subsets = subsets.filter((subset) => subset.hidden === false);
        vm.subsets = subsets;
    }

    function downloadSubsets(subset) {
        return djangoClient
            .post('/api/1/download', {
                web: vm.web,
                styles: vm.licenses.map((license) => license.style.id),
                subset,
            })
            .then((response) => {
                const downloadUrl =
                    apiBaseURl +
                    (response.slice(-1) === '/'
                        ? response.slice(0, -1)
                        : response);
                $window.location.href = downloadUrl;
            });
    }
}
